<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="px-5 py-2">
          <manage-organism-details />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ManageOrganismDetails from "@/components/bnc/ManageOrganismDetails";
import TopHeader from "@/components/base/TopHeader";
export default {
  components: {
    ManageOrganismDetails
  },
  data() {
    return {};
  }
};
</script>

<style scoped></style>
